import axios, { AxiosHeaders, CreateAxiosDefaults } from "axios";

const headers = new AxiosHeaders();

headers.set("Content-Type", "application/json");
headers.set("x-client-id", "thorswap-be");
headers.set("Referer", "api.thorswap.net");

export const getAxiosClient = (options?: CreateAxiosDefaults) =>
  axios.create({
    headers,
    ...options,
  });

export const THORCHAIN_BLOCK_TIME = 6;
export const THORNAME_REGEXP_VALID_WORD = /^[a-zA-Z0-9+_-]+$/;
export const THORNAME_REGEXP_INVALID_CHAR = /[^a-zA-Z0-9+_-]/g;
